export const WS_BASE = process.env.REACT_APP_WS_BASE;
